import { AuthConfig } from 'angular-oauth2-oidc';

export const authConfig: AuthConfig = {
  issuer: 'https://accounts.google.com',
  strictDiscoveryDocumentValidation: false,
  clientId: '301165535126-69o06k0hujh4f12baauugie0qq48qi92.apps.googleusercontent.com',
  redirectUri: window.location.origin+'/main/',
  scope: 'openid profile email',
};
